import { render, staticRenderFns } from "./BSLocal.vue?vue&type=template&id=150189df&"
import script from "./BSLocal.vue?vue&type=script&lang=js&"
export * from "./BSLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports